import MarginTabletInfo from "./MarginTabletInfo";

export default MarginTabletInfo;